import EmailSent from './EmailSent'
import PasswordCreation from './PasswordCreation'
import PasswordRecover from './PasswordRecover'
import PasswordSuccess from './PasswordSuccess'

export {
  EmailSent,
  PasswordCreation,
  PasswordRecover,
  PasswordSuccess,
}
